import React, { useState } from 'react';
import { connect } from 'react-redux';
import { FormGroup } from '@blueprintjs/core';
import Row from 'containers/Reports/row';
import { DatePicker } from '@blueprintjs/datetime';
import { runPendingRenewalsReport } from 'actions/reports';
import moment from 'moment';
import { getMaxDate } from 'utils/functions';

const PendingRenewalsBase = ({
  runPendingRenewalsReport,
  report,
  isFetchingReport,
  isLoadedReport,
  errorMessage,
}) => {
  const [selectedDate, setDate] = useState(new Date());

  const handleChange = (selected, setter) => {
    setter(selected);
  };

  return (
    <Row
      name="Pending Renewals"
      description="Assessments that are up for renewal within a date range."
      drawer={
        <div style={{ width: '50%' }}>
          <FormGroup label="Upcoming Renewals On and After Date">
            <DatePicker
              value={selectedDate}
              onChange={selected => handleChange(selected, setDate)}
              maxDate={getMaxDate()}
            />
          </FormGroup>
        </div>
      }
      runReport={() =>
        runPendingRenewalsReport({
          date: {
            date: moment(selectedDate).format('YYYY-MM-DD'),
            dateCheck: 'AFTER',
          },
        })
      }
      isFetchingReport={isFetchingReport}
      isLoadedReport={isLoadedReport}
      data={report}
      errorMessage={errorMessage}
      headers={[
        { label: 'Assessment ID', key: 'vendorRequestID' },
        { label: 'Third Party', key: 'vendorName' },
        { label: 'Product or Service', key: 'productServiceName' },
        { label: 'Status', key: 'requestStatus' },
        { label: 'Approval Date', key: 'approvalDate' },
        { label: 'Renewal Date', key: 'renewalDate' },
        { label: 'Sponsor Name', key: 'sponsorLastName' },
        { label: 'Sponsor Department', key: 'sponsorDepartment' },
        { label: 'Requesting Departments', key: 'departmentsRequesting' },
        { label: 'Conditional Approval Comments', key: 'overrideNote' },
      ]}
      resetDrawerState={() => {
        setDate(new Date());
      }}
    />
  );
};

const mapStateToProps = state => ({
  report: state.reports.pendingRenewals,
  isFetchingReport: state.reports.isFetching,
  isLoadedReport: state.reports.isLoaded,
  errorMessage: state.reports.errorMessage,
});

const PendingRenewals = connect(
  mapStateToProps,
  { runPendingRenewalsReport }
)(PendingRenewalsBase);

export default PendingRenewals;
